import { JsonService } from './service/json.service';
import { HttpModule } from '@angular/http';
import { JobService } from './service/job.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { FormsModule } from '@angular/forms';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { OffersMicroSitesComponent } from './offers-micro-sites/offers-micro-sites.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    OffersMicroSitesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    FormsModule,
    NgbModule.forRoot()
  ],
  providers: [
    JobService,
    JsonService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts